const { surfacesToFeedHeightMap } = require('./feed-surface-analysis');
const { computeFeedMetrics } = require('./feed-volume');
const { makeSurfaceFromReading } = require('./reading-to-surface');
const { heightMapToBuffer, bufferToHeightMap, uInt8ArrayToHeightMap } = require('./height-map-parser');
const { feedHeightConstraint } = require('./height-map-helpers');
const { distanceToBin, BinGeometry, binGeometryFromBin } = require('./geometry/bin-geometry');
const { cameraRotationDetection, scoreRotation } = require('./camera-rotation-detection');
const { depthArrays, smoothDepths } = require('./depths');
const { readingToHeightMap, readingToFeedHeightMap } = require('./reading-to-feed-height-map');
const { feedMaskPixelTypes, makeFeedMask } = require('./feed-masks');

exports.feedMaskPixelTypes = feedMaskPixelTypes;
exports.surfacesToFeedHeightMap = surfacesToFeedHeightMap;
exports.feedHeightConstraint = feedHeightConstraint;
exports.makeSurfaceFromReading = makeSurfaceFromReading;
exports.changeSurfaceToBinsCoordinateSystem = function (rawSurface, bin, tilt, pan) {
  return binGeometryFromBin(bin).changeSurfaceToBinsCoordinateSystem(rawSurface, tilt, pan);
};
exports.heightMapToBuffer = heightMapToBuffer;
exports.bufferToHeightMap = bufferToHeightMap;
exports.uInt8ArrayToHeightMap = uInt8ArrayToHeightMap;

/**
 * @deprecated Create a bin geometry from the bin object instead
 */
exports.distanceToBin = distanceToBin;
exports.cameraRotationDetection = function (image, feedMask, bin, customSearchSettings = {}) {
  return cameraRotationDetection(image, feedMask, binGeometryFromBin(bin), customSearchSettings);
};
exports.depthArrays = depthArrays;
exports.smoothDepths = smoothDepths;
exports.readingToFeedHeightMap = readingToFeedHeightMap;
exports.makeFeedMask = makeFeedMask;
exports.scoreRotation = function (pan, tilt, distanceScale, bin, image, feedMask) {
  return scoreRotation(pan, tilt, distanceScale, binGeometryFromBin(bin), image, feedMask);
};

exports.BinGeometry = BinGeometry;
exports.binGeometryFromBin = binGeometryFromBin;

/**
 * @deprecated Use readingToFeedHeightMap() instead
 */
exports.readingToHeightMap = readingToHeightMap;
/**
 * @deprecated
 */
exports.computeFeedMetrics = computeFeedMetrics;
